<script>
import {
  clientData,
  setClientDataValue,
  saveClientData,
} from '@/stores/clientData'

import { giftFieldErrorKeys, setGiftFieldErrorKey } from '@/stores/gift'

import TextField from '@/components/Form/TextField'
import TextareaField from '@/components/Form/TextareaField'
import BooleanField from '@/components/Form/BooleanField'
import Button from '@/components/Button'
import { computed } from 'vue'

export default {
  components: {
    TextField,
    TextareaField,
    BooleanField,
    Button,
  },
  props: {
    locked: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const isGift = computed(() => {
      return !!(clientData.value && clientData.value['is_gift'])
    })

    const recipientName = computed(() => {
      if (clientData.value && clientData.value['gift_recipient_name']) {
        return clientData.value['gift_recipient_name']
      }
      return ''
    })

    const recipientText = computed(() => {
      if (clientData.value && clientData.value['gift_recipient_text']) {
        return clientData.value['gift_recipient_text']
      }
      return ''
    })

    const giverName = computed(() => {
      if (clientData.value && clientData.value['gift_giver_name']) {
        return clientData.value['gift_giver_name']
      }
      return ''
    })

    let saveTimeout
    const saveData = () => {
      clearTimeout(saveTimeout)
      saveTimeout = setTimeout(() => {
        saveClientData()
      }, 100)
    }

    const viewPreviewPdf = () => {
      window.open(`get/api/template/basket/preview_gift_pdf`, '_blank').focus()
    }

    return {
      isGift,
      recipientName,
      recipientText,
      giverName,
      setClientDataValue,
      saveData,
      viewPreviewPdf,
      giftFieldErrorKeys,
      setGiftFieldErrorKey,
    }
  },
}
</script>

<template>
  <div class="mt-12 mb-12">
    <BooleanField
      :label="__('form.is_gift')"
      value="1"
      :disabled="loading"
      :model-value="isGift"
      @change.stop="
        (event) => [
          setClientDataValue('is_gift', event.target.checked),
          saveData(),
        ]
      "
    />

    <div class="mt-8 mb-16" v-if="isGift">
      <p class="italic" v-html="__('gift_card_description')"></p>

      <div class="flex flex-wrap -m-3">
        <div class="w-full lg:w-1/2 p-3">
          <TextField
            :label="__('form.gift_giver_name')"
            :disabled="locked"
            :required="true"
            :model-value="giverName"
            :error="giftFieldErrorKeys.includes('gift_giver_name')"
            @change="
              (event) => [
                setClientDataValue('gift_giver_name', event.target.value),
                saveData(),
                setGiftFieldErrorKey('gift_giver_name', true),
              ]
            "
          />
        </div>

        <div class="w-full lg:w-1/2 p-3">
          <TextField
            :label="__('form.gift_recipient_name')"
            :disabled="locked"
            :required="true"
            :model-value="recipientName"
            :error="giftFieldErrorKeys.includes('gift_recipient_name')"
            @change="
              (event) => [
                setClientDataValue('gift_recipient_name', event.target.value),
                saveData(),
                setGiftFieldErrorKey('gift_recipient_name', true),
              ]
            "
          />
        </div>

        <div class="w-full p-3">
          <TextareaField
            :label="__('form.gift_recipient_text')"
            height="!h-60 sm:!h-40 lg:!h-34 2xl:!h-32"
            :maxLength="190"
            :disableNewLine="true"
            :disabled="locked"
            :required="true"
            :model-value="recipientText"
            :error="giftFieldErrorKeys.includes('gift_recipient_text')"
            @change="
              (event) => [
                setClientDataValue('gift_recipient_text', event.target.value),
                saveData(),
                setGiftFieldErrorKey('gift_recipient_text', true),
              ]
            "
          />
        </div>
      </div>

      <div class="mt-4">
        <Button @click="viewPreviewPdf()">
          {{ __('view_gift_card') }}
        </Button>
      </div>
    </div>
  </div>
</template>
